import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Modal from './Modal'

import '../styles/Navigator.css'

class Navigator extends Component {
  constructor (props) {
    super(props)

    this.state = {
      modalActive: false
    }
  }

  _navigate () {
    const {
      history,
      type,
      id
    } = this.props

    if (type.toLowerCase() === 'modal') {
      this.setState({ modalActive: true })
    } else {
      history.push(`/${type}/${id}`)
    }
  }

  _closeModal () {
    this.setState({ modalActive: false })
  }

  _renderModal () {
    if (this.state.modalActive) {
      return (
        <Modal modalId={this.props.id} onClose={() => this._closeModal()} />
      )
    }

    return null
  }

  render () {
    return (
      <div style={this.props.style} onClick={() => this._navigate()} className='Navigator'>
        <div>
          {this.props.children}
        </div>

        {this._renderModal()}
      </div>
    )
  }
}

Navigator.propTypes = {
  history: PropTypes.object,
  style: PropTypes.object,
  type: PropTypes.string,
  id: PropTypes.number,
  children: PropTypes.any
}

export default Navigator



// WEBPACK FOOTER //
// ./src/components/Navigator.js